import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { Badge } from "@/components/ui/badge";

export default function DebiteurenPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api.get("/debiteuren")
       .then(r => setRows(r.data))
       .finally(() => setLoading(false));
  }, []);

  const columns = [
    { key: "achternaam", label: "Ouder", render: r => (
      <div>
        <div className="font-medium">{r.voornaam} {r.achternaam}</div>
        <div className="text-xs text-neutral-500">{r.email}</div>
      </div>
    )},
    { key: "iban", label: "IBAN", render: r => <span className="font-mono text-xs">{r.iban || "—"}</span> },
    { key: "machtiging", label: "Machtiging", render: r => r.machtiging
      ? <Badge className="bg-emerald-50 text-emerald-700 border-emerald-200 border" variant="outline">Ja</Badge>
      : <Badge className="bg-red-50 text-red-700 border-red-200 border" variant="outline">Nee</Badge>
    },
    { key: "aantal", label: "Aantal facturen", render: r => <span className="font-mono">{r.aantal}</span> },
    { key: "overtijd", label: "Overtijd", render: r => r.overtijd > 0
      ? <Badge className="bg-red-50 text-red-700 border-red-200 border" variant="outline">{r.overtijd} overtijd</Badge>
      : <span className="text-neutral-400 text-xs">—</span> },
    { key: "openstaand", label: "Openstaand", render: r => <span className="font-mono font-semibold text-red-700">€ {r.openstaand.toLocaleString('nl-NL', { minimumFractionDigits: 2 })}</span> },
  ];

  const total = rows.reduce((a, r) => a + r.openstaand, 0);

  return (
    <div>
      <PageHeader
        title="Debiteuren"
        subtitle="Openstaande facturen gegroepeerd per ouder — snelle inzage voor incasso en herinnering."
        testid="debiteuren-header"
      />
      <div className="mb-6 p-6 bg-white rounded-lg border border-neutral-200 flex items-center justify-between">
        <div>
          <div className="text-xs text-neutral-500 uppercase tracking-wider">Totaal openstaand</div>
          <div className="font-display text-3xl text-red-700 mt-1">€ {total.toLocaleString('nl-NL', { minimumFractionDigits: 2 })}</div>
        </div>
        <div className="text-sm text-neutral-500">{rows.length} debiteuren</div>
      </div>
      <DataTable columns={columns} rows={rows} keyField="ouder_id" testid="debiteuren-table"
                 loading={loading} skeletonRows={6} />
    </div>
  );
}
